// Stock-issues dashboard is limited to a small pilot group while the
// feature is still being shaped. Adding another user is a one-line
// change here + a mirror in firebase/functions/src/stockIssues/auth.ts.
// Keep the two lists in sync.
//
// Pure helper — no JSX. The route-guard component lives in
// StockIssuesRouteGuard.jsx so this file can stay as plain .js.
const STOCK_ISSUES_ALLOWED_EMAILS = new Set([
  "sharronb@stormtech.ca",
  "scott@bhainc.ca",
]);

export function canAccessStockIssues(user) {
  const email = user?.email?.toLowerCase();
  if (!email) return false;
  return STOCK_ISSUES_ALLOWED_EMAILS.has(email);
}
